export const reducer = (state, action) => {
  if (action.type === "NEW_TODO") {
    return {
      ...state,
      _todos: [
        ...state._todos,
        { ...action.payload, id: state._todos.length + 1 },
      ],
    };
  }

  if (action.type === "CHANGE_TODO_STATUS") {
    const { id, status } = action.payload;
    const newTodos = state._todos.map((item) => {
      if (item.id === id) {
        item.status = status;
      }
      return item;
    });
    return { ...state, todos: newTodos };
  }

  if (action.type === "FILTER_TODOS") {
    const { value } = action.payload;

    let newTodos;
    if (value === "all") {
      newTodos = state._todos;
    }

    if (value === "active") {
      newTodos = state._todos.filter((item) => !item.status);
    }

    if (value === "completed") {
      newTodos = state._todos.filter((item) => item.status);
    }

    return { ...state, todos: newTodos, loading: false };
  }

  if (action.type === "CALCULATE_TOTAL_LEFT") {
    const newTotal = state._todos.reduce((acc, item, i) => {
      if (!item.status) {
        acc = acc + 1;
      }
      return acc;
    }, 0);
    return { ...state, totalTodos: newTotal };
  }

  if (action.type === "CLEAR_COMPLETED") {
    const newTodos = state._todos.filter((item) => !item.status);
    return { ...state, _todos: newTodos };
  }

  if (action.type === "CLEAR_TODO") {
    const newTodos = state._todos.filter((item) => item.id !== action.payload);
    return { ...state, _todos: newTodos };
  }

  return state;
};
